import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';


export interface ISdsAction{
  action:string;
  value:any;
}

@Injectable({
  providedIn: 'root'
})
export class SdsService {
  private _action$ = new Subject<ISdsAction>();

  get actions(): Observable<ISdsAction> {
      return this._action$.asObservable();
  }

  newAction(newAction: ISdsAction) {
     this._action$.next(newAction);
  }

  constructor() { }


}


